import React from 'react'
import Header from '../../Header'
import Footer from '../../Footer'
import TermsOfUse from './TermsOfUse'

export default function index() {
  return (
    <div>
        <Header/>
        <TermsOfUse/>
        <Footer/>
    </div>
  )
}
